import styled from '@emotion/styled';

export type StyledCampaignDiscountProps = React.HTMLAttributes<HTMLDivElement>;

const StyledCampaignDiscount = styled.div<StyledCampaignDiscountProps>(
  {
    alignItems: 'center',
    borderRadius: 6,
    borderStyle: 'solid',
    borderWidth: 1,
    display: 'inline-flex',
    fontSize: 14,
    fontWeight: 400,
    gap: 11,
    marginBottom: 10,
    padding: 16
  },
  ({ theme }) => ({
    borderColor: theme.palette.colors.orangeRed,
    color: theme.palette.colors.midnightBlue,
    backgroundColor: theme.palette.colors.lotion
  })
);

export default StyledCampaignDiscount;
